import { createFileRoute } from "@tanstack/react-router";

import { OrgOnboardingContainer } from "@/features/onboarding/containers/org-onboarding-container";

export const Route = createFileRoute("/onboarding/org")({
  component: OrgOnboardingContainer,
});
